var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 52 52",
    strokeWidth: 0,
    fill: "currentColor",
    size: 16,
    "data-testid": "receipt-trip-summary-child-icon",
    width: 16,
    height: 16,
    style: {
      pointerEvents: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".Icon-child_svg__st0{display:none}.Icon-child_svg__st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st2{display:inline}.Icon-child_svg__st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-child_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-child_svg__st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-child_svg__st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-child_svg__st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-child_svg__st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-child_svg__st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st17{fill:none}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-child_svg__stroke",
    className: "Icon-child_svg__st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Icon-child_svg__st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Icon-child_svg__st10",
    d: "M19,29c0,1.0625,1,2,2,2h10c1,0,2-1,2-2v-6c0-3-2.1875-4-5-4h-4c-3,0-5,1-5,4V29z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Icon-child_svg__st7",
    cx: 26,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "Icon-child_svg__st10",
    points: "21,30.5 21,39 31,39 31,30.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "Icon-child_svg__st3",
    x1: 26,
    y1: 38,
    x2: 26,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    className: "Icon-child_svg__st3",
    x1: 23,
    y1: 39,
    x2: 23,
    y2: 47
  }), /*#__PURE__*/React.createElement("line", {
    className: "Icon-child_svg__st3",
    x1: 29,
    y1: 39,
    x2: 29,
    y2: 47
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon-child_svg__filled"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 10,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,48c0.5522,0,1-0.4473,1-1v-7h1c0.5522,0,1-0.4473,1-1v-6H20v6c0,0.5527,0.4478,1,1,1h1v7c0,0.5527,0.4478,1,1,1 s1-0.4473,1-1v-7h1v-4c0-0.5527,0.4478-1,1-1s1,0.4473,1,1v4h1v7C28,47.5527,28.4478,48,29,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,29v-6c0-1.8672-0.7793-5-6-5h-4c-4.959,0-6,2.7188-6,5v6c0,0.7479,0.3279,1.4581,0.8383,2h14.3052 C33.6627,30.4536,34,29.7389,34,29z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.47cd53db384ad07a5e690b3e561f77ee.svg";
export { ForwardRef as ReactComponent };